import React from 'react';
import LegalPage from './LegalPage';
import { termsOfUse } from './legalContent';

// Swap `termsOfUse` for data from the API once the team provides the final text.
const TermsOfUsePage = () => (
  <LegalPage doc={termsOfUse} other={{ to: '/privacypolicy', label: 'privacy policy' }} />
);

export default TermsOfUsePage;
